import {
	Component,
	OnInit,
	Input,
	OnChanges,
	SimpleChanges,
	Output,
	EventEmitter,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { AgentStatisticsService } from "src/app/shared/services/agent-statistics.service";
import { AgentGameGroupSalesStatistics } from "src/app/shared/models/agent-sales-statistics.model";

@Component({
	selector: "ra-stats-list",
	templateUrl: "./stats-list.component.html",
	styleUrls: ["./stats-list.component.scss"],
})
export class StatsListComponent implements OnInit, OnChanges {
	@Input() dateFrom: Date;
	@Input() dateTo: Date;

	statistics: AgentGameGroupSalesStatistics[] = [];

	@Output() onStatsReceived = new EventEmitter<
		AgentGameGroupSalesStatistics[]
	>();

	isLoading = false;

	getDataError = false;

	constructor(
		private translate: TranslateService,
		private agentStatisticsService: AgentStatisticsService
	) {}

	ngOnInit() {
		this.getSTatistics();
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes !== undefined) {
			if (
				!changes["dateFrom"].isFirstChange() &&
				!changes["dateTo"].isFirstChange()
			) {
				if (
					changes["dateFrom"].currentValue !==
						changes["dateFrom"].previousValue ||
					changes["dateTo"].currentValue !==
						changes["dateTo"].previousValue
				) {
					this.getSTatistics();
				}
			}
		}
	}

	private getSTatistics = async () => {
		if (!this.isLoading) {
			this.isLoading = true;
			this.getDataError = false;

			let allGames = await this.translate
				.get("sales-stats.all-games")
				.toPromise();

			try {
				let statistics = await this.agentStatisticsService
					.getSalesStatistics(this.dateFrom, this.dateTo)
					.toPromise();

				this.isLoading = false;

				statistics.gameGroupStatistics.unshift({
					orderNo: 0,
					gameGroup: allGames,
					gameGroupCode: "",
					betCount: statistics.totalBets,
					participationCount: statistics.totalParticipations,
					totalSales: statistics.totalSales,
					totalPayouts: statistics.totalPayouts,
					totalCancelled: statistics.totalCancelled,
				});

				this.onStatsReceived.emit(statistics.gameGroupStatistics);
				this.statistics = statistics.gameGroupStatistics;

				return statistics.gameGroupStatistics;
			} catch (ex) {
				this.isLoading = false;
				this.getDataError = true;
			}
		}
	};
}
